import React, { useState } from "react";
import styled from "styled-components";
import media from "cssMix/index";
import avatarList from "config/avatarList";
import ReactModal from "Components/common/ReactModal";
import Avatar from "./Avatar";
import AvatarPopup from "./AvatarPopup";
import cx from "classnames";
// icon
// import { FiMoreHorizontal } from "react-icons/fi"
// import { IoMdRefresh } from "react-icons/io"

export default ({
  t,
  account,
  balance,
  currency,
  refresh,
  handleRefreshClick,
  dispatch,
  userInfo,
}) => {
  const [avatarPopup, setAvatarPopup] = useState(false);
  const avatarPopHandler = () => {
    setAvatarPopup(!avatarPopup);
  };
  const userAvatar = userInfo.get("avatar")
    ? userInfo.get("avatar") === ""
      ? "1"
      : userInfo.get("avatar")
    : "1";
  return (
    <Account>
      <Avatar
        userAvatar={userAvatar}
        avatarPopHandler={avatarPopHandler}
        account={account}
        handleRefreshClick={handleRefreshClick}
        refresh={refresh}
        balance={balance}
        currency={currency}
        avatarList={avatarList}
      />
      <ReactModal
        isOpen={avatarPopup}
        onModalClose={() => setAvatarPopup(false)}
      >
        <AvatarPopup
          t={t}
          avatarPopHandler={avatarPopHandler}
          userAvatar={userAvatar}
          dispatch={dispatch}
          avatarList={avatarList}
        />
      </ReactModal>
      <Amount
        balance={balance}
        currency={currency}
        handleRefreshClick={handleRefreshClick}
        refresh={refresh}
      />
    </Account>
  );
};

const Amount = ({ currency, balance, handleRefreshClick, refresh }) => {
  return (
    <StyledAmount balance={balance}>
      <div className="container">
        <div>
          <div className="bx bxs-coin-stack" style={{ fontSize: "24px" }}></div>
          <p className="currency">{currency}</p>
        </div>
        <div>
          <p className="balance">{balance}</p>
          <div
            className={cx([
              "bx bx-refresh gav2_btn_balance",
              {
                refresh: refresh,
              },
            ])}
            style={{ fontSize: "24px", color: "#f9be00", cursor: "pointer" }}
            onClick={handleRefreshClick}
          />
          <div
            className={cx([
              "coin",
              {
                refresh: refresh,
              },
            ])}
          />
        </div>
      </div>
    </StyledAmount>
  );
};

const Account = styled.div`
  width: 100%;
  position: relative;
  ${media.tablet`
    margin:0;
`}
`;

const StyledAmount = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 93px;
  margin: 32px 0;
  padding: 1px;
  border-radius: 10px;
  border-image-source: linear-gradient(
    115deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.55) 33%,
    rgba(255, 255, 255, 0.15) 72%,
    rgba(255, 255, 255, 0.25) 99%
  );
  border-image-slice: 1;
  background-image: linear-gradient(to bottom, #322b6e, #322b6e),
    linear-gradient(
      115deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.55) 33%,
      rgba(255, 255, 255, 0.15) 72%,
      rgba(255, 255, 255, 0.25) 99%
    );
  background-origin: border-box;
  background-clip: content-box, border-box;
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
  @keyframes coin {
    0% {
      bottom: 0;
      opacity: 0;
    }
    50% {
      bottom: 25px;
      opacity: 1;
    }
    100% {
      bottom: 0;
      opacity: 0;
    }
  }
  & .bx {
    z-index: 1;
    &.refresh {
      animation: rotate 0.7s ease-in-out;
    }
  }
  & .coin {
    display: block;
    width: 25px;
    height: 25px;
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translateY(-50%);
    background-image: url("images/coin.gif");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0;
    &.refresh {
      animation: coin 1s ease forwards;
    }
  }
  & .container {
    width: calc(100% - 24px);
    height: 100%;
    /* background-color: rgba(0,0,0,.3) ; */
    & > div {
      position: relative;
      color: #fff;
      width: 100%;
      height: 50%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      & .currency {
        font-size: 12px;
      }
    }
    & > div:first-child {
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    }
    & .balance {
      font-size: ${(props) => (props.balance.length > 20 ? "14px" : "16px")};
    }
  }
  ${media.tablet`
  margin: 16px 0 32px;
  
  `}
`;
